// extracted by mini-css-extract-plugin
module.exports = {"container":"comments-module--container--3gk-t"};